function parseBloomreachImage(image) {
    var ref, ref1;
    if (!image) {
        return undefined;
    }
    var _description, _description1, _description2;
    return {
        alt: (_description = image.description) !== null && _description !== void 0 ? _description : '',
        original: {
            alt: (_description1 = image.description) !== null && _description1 !== void 0 ? _description1 : '',
            url: ((ref = image.original) === null || ref === void 0 ? void 0 : ref.url) || '',
            dimensions: getDimensions(image.original)
        },
        mobile: {
            alt: (_description2 = image.description) !== null && _description2 !== void 0 ? _description2 : '',
            url: ((ref1 = image.mobile) === null || ref1 === void 0 ? void 0 : ref1.url) || '',
            dimensions: getDimensions(image.mobile)
        }
    };
}
function getDimensions(input) {
    return {
        w: (input === null || input === void 0 ? void 0 : input.width) || 0,
        h: (input === null || input === void 0 ? void 0 : input.height) || 0
    };
}

export { parseBloomreachImage };
//# sourceMappingURL=parse-bloomreach-image.js.map
